import React, { useState, useEffect } from 'react';
import HotelRating from '../../views/Global/hotelRating';
import commonConst from '../../constants/common';
const env = process.env.NODE_ENV ? process.env.NODE_ENV : 'development';
const config = require(`../../config/${env}`) || {};
const { redirectionDomains: _redirectionDomains = "", baseUrl = '', serviceProtocol = "" } = config
const { TNC = [] } = commonConst;
import APP from 'app';
const { getQueryObjectFromUrlExact, dateDiff, errorToaster } = APP.Utils;
import InputField from '../../components/common/InputField';
import Button from '../../views/Global/button';
import TgsFullLoader from './../../components/common/loader/FullLoader';
import '../../css/layout/hcnUpdate/hcnUpdate.less'
import CheckmarkCircle from '../common/CheckMark/CheckmarkCircleSvg';
import EmptyLoader from '../../views/Global/Loaders/EmptyLoader';


const HcnDetails = (props) => {

    const [hcnData, setHcnData] = useState({})

    const { bookingDetails = {}, getOpenBookingDetails, fetchingBookingDetails = false, hcnUpdateSubmit, hcnUpdateResponse = false, updatingHcn = false } = props,
        { searchQuery = {}, ris = [], hInfo = "" } = bookingDetails,
        { checkinDate = '', checkoutDate = '' } = searchQuery;
    const { name: hotelName = "" } = hInfo
    const [firstRis = {}] = ris,
        { ti = [] } = firstRis,
        [firstTi = {}] = ti,
        { fN: firstFn = "", lN: firstLn = "" } = firstTi;
    const getUrl = window.location.search;
    const urlData = getQueryObjectFromUrlExact(getUrl);
    const { id = "" } = urlData;
    useEffect(() => {
        getOpenBookingDetails({ email: id })
    }, [])


    const handleInputChange = (val, context) => {
        setHcnData({ ...hcnData, [context]: val })
    }

    const handleSubmit = () => {
        if (!hcn) {
            errorToaster('HCN Cannot Be Blank', 2000, 'error');
            return
        }

        const payload = {
            hcnInfo: {
                bid: id,
                hcn: hcn,
                ad: {
                    hci: {
                        nm: "HCNFromHotelier"
                    }
                }
            }
        }
        hcnUpdateSubmit(payload)
    }
    const handleClose = () => {
        window.close()
    }

    const { hcn = "" } = hcnData;
    return (
        <>
            {fetchingBookingDetails ?
                <div className="hotel__container">
                    <EmptyLoader />
                </div>
                :

                <div className="hcn_container">
                    {hcnUpdateResponse ?
                        <div className=" submitModal styles_overlay__CLSq- styles_overlayCenter__YHoO7 undefined">
                            <div className="styles_modal__gNwvD promtbox__wrapper">
                                <div style={{ display: "flex" }} className="submitModal__heading" >

                                    <p> <i className="fas fa-check-circle" style={{ "color": "rgb(43 155 82 / 79%)" }}></i></p>
                                    <p className="">HCN Updated</p>
                                </div>
                                <div className="success_icon">
                                    <CheckmarkCircle />
                                </div>
                                <p className="submitModal__content"> The HCN Has Been Updated Successfully. </p>
                                <div className="submitModal__button">
                                    <Button
                                        displayLabel={"Close"}
                                        className='updateHcnButton'
                                        type='button'
                                        onClick={handleClose}
                                    />
                                </div>
                            </div>
                        </div>
                        :
                        <div className="mainDiv">
                            <div className="mainDiv__upper"  >
                                <span className="mainDiv__upper--span1" >
                                    <img src={`${serviceProtocol}:${baseUrl}/img/booking.png`} alt="success icon " />
                                </span>
                                <span className="mainDiv__upper--span2" >
                                    BOOKING CONFIRMATION
                                </span>

                            </div>

                            <div className="mainDiv__lower">

                                <div className="mainDiv__lower--info" >

                                    <p className="boldd para" style={{ fontSize: "17px" }} >
                                        Hi Team {hotelName},
                                    </p>

                                    <p className="para" >
                                        {firstFn} {firstLn} has recently made a reservation at your hotel for an upcoming stay.
                                    </p>
                                    <p className="para" >
                                        Please find the
                                        complete booking details below.We kindly request that you click the provided link to update the Hotel
                                        Confirmation Number (HCN).This will facilitate the reconfirmation of the booking for both the guest and
                                        our records.
                                    </p>

                                </div>
                                <p className="bold label" >HCN</p>
                                <div className="mainDiv__lower--hcnInfo" >
                                    <InputField
                                        placeholder={"Enter Your HCN"}
                                        className={''}
                                        type={'text'}
                                        name={'hcn'}
                                        value={hcn}
                                        maxlength={"20"}
                                        handleInputChange={handleInputChange}
                                        context="hcn"
                                        parentClassName={'width70'}
                                    />
                                    <Button
                                        displayLabel={"UPDATE HCN"}
                                        className='updateHcnButton'
                                        type='button'
                                        onClick={handleSubmit}
                                    />

                                </div>
                                <div className="mainDiv__lower--infotable"  >
                                    <div className="table-container">
                                        <table className="my-table">
                                            <thead>
                                                <tr>
                                                    <th>Guest Name</th>
                                                    <th>Check-in</th>
                                                    <th>Check-out</th>
                                                    <th>Room Type</th>
                                                    <th>Total Nights</th>
                                                    <th>Meal Plan</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ris.map((roomInfo, roomIndex) => {
                                                    const { rt = "", rc = "", mb = "", ti = [] } = roomInfo
                                                    return <React.Fragment key={roomIndex}>
                                                        {ti.map((travInfo, travIndex) => {
                                                            const { fN = "", lN = "", ti: title = "" } = travInfo
                                                            return <tr key={`${roomIndex}-${travIndex}`} style={(travIndex === (ti.length - 1)) ? { borderBottom: "0.9px solid #d9d9d9" } : {}} >
                                                                {/* {travIndex === 0 && (
                                                                    <td rowSpan={ti.length}> {roomIndex + 1}</td>
                                                                )} */}
                                                                <td>{title} {fN} {lN}</td>

                                                                {travIndex === 0 && (
                                                                    <>
                                                                        <td>{checkinDate}</td>
                                                                        <td>{checkoutDate}</td>
                                                                        <td>{rt || rc}</td>
                                                                        <td>{`${dateDiff(checkoutDate, checkinDate)}`}</td>
                                                                        <td>{mb}</td>
                                                                    </>
                                                                )}
                                                            </tr>
                                                        })}

                                                    </React.Fragment>

                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="mainDiv__lower--belowInfo" >
                                    <p className="para" >To emphasize, updating the HCN here will help reduce the need for
                                        multiple calls from both guests and our team to reconfirm the booking.</p>
                                    <p className="para" >We sincerely thank you for your support and kind patronage.</p>
                                    <p className="para" >Thank you.</p>
                                </div>
                            </div>

                        </div>
                    }
                    <div className="upperBg">
                        {/* upper */}
                    </div>
                    <div className="lowerBg">
                        {/* lower */}
                    </div>


                </div>
            }
        </>
    );
}

export default HcnDetails;
